import {
  EffectComposer,
  Bloom,
  Vignette,
  Noise,
  ChromaticAberration,
} from '@react-three/postprocessing'
import { BlendFunction } from 'postprocessing'
import { useMemo } from 'react'
import { useThree } from '@react-three/fiber'
import * as THREE from 'three'
import { useExperienceStore } from '../store/experienceStore'
import { QUALITY_PRESETS } from '../config/quality'

export function PostFX() {
  const { size } = useThree()
  const quality = useExperienceStore((s) => s.quality)
  const timeSpeed = useExperienceStore((s) => s.timeSpeed)
  const traverseIntensity = useExperienceStore((s) => s.traverseIntensity)
  const cfg = QUALITY_PRESETS[quality]

  const speedAbs = Math.abs(timeSpeed)
  const bloomIntensity = 0.55 + speedAbs * 1.4 + traverseIntensity * 0.6
  const chroma = useMemo(() => new THREE.Vector2(0.0008, 0.0008), [])
  chroma.set(
    0.0006 + speedAbs * 0.004 + traverseIntensity * 0.003,
    0.0004 + speedAbs * 0.003 + traverseIntensity * 0.002,
  )

  // Avoid black composer when canvas has not sized yet
  if (size.width < 64 || size.height < 64) return null

  return (
    <EffectComposer
      multisampling={quality === 'low' ? 0 : 2}
      enableNormalPass={false}
    >
      {cfg.bloom ? (
        <Bloom
          intensity={bloomIntensity}
          luminanceThreshold={0.25}
          luminanceSmoothing={0.4}
          mipmapBlur
        />
      ) : (
        <></>
      )}
      {cfg.afterimage ? (
        <ChromaticAberration
          blendFunction={BlendFunction.NORMAL}
          offset={chroma}
          radialModulation={false}
          modulationOffset={0}
        />
      ) : (
        <></>
      )}
      {cfg.distortion ? (
        <Noise
          premultiply
          blendFunction={BlendFunction.SOFT_LIGHT}
          opacity={0.03 + traverseIntensity * 0.05}
        />
      ) : (
        <></>
      )}
      <Vignette offset={0.2} darkness={0.5} />
    </EffectComposer>
  )
}
